/**
 * 按日期查询拍卖场次
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取拍卖场次列表
// 接口地址   /api/v1/auctions/sessions/query
Mock.mock(/\/auctions\/sessions\/query/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'id': 2,
    'name': '2017年3月22日 15:00场',
    'auction_count': 111,
    'started_at': '2017-03-22 18:00:00',
    'ended_at': '2017-03-22 23:59:59'
  }
})
